import React from 'react'

function Drivers() {
  return (
      <div className="container" style={{ padding: "20px", marginTop: "50px" }}>
          <h5 className="heading-title mt-4">Drivers</h5>
           <div className="card p-3 mb-3">
            <div className="d-flex gap-2"></div>
           </div>
          </div>
  )
}

export default Drivers